import { useEffect } from 'react';
import type { ReactNode } from 'react';

/** Шторки и модальные диалоги (SPEC §3.3). */

function useEscape(onClose: () => void) {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handler);
      document.body.style.overflow = previous;
    };
  }, [onClose]);
}

export function Sheet({
  title,
  subtitle,
  onClose,
  children,
  full = false,
  hideGrab = false,
}: {
  title?: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
  full?: boolean;
  hideGrab?: boolean;
}) {
  useEscape(onClose);

  return (
    <div
      className="overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className={full ? 'sheet full' : 'sheet'}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        {hideGrab ? null : <div className="grab" />}
        {title ? <h2>{title}</h2> : null}
        {subtitle ? (
          <p className="nt" style={{ margin: '2px 0 0' }}>
            {subtitle}
          </p>
        ) : null}
        {children}
      </div>
    </div>
  );
}

export function Dialog({
  title,
  children,
  confirmLabel,
  cancelLabel = 'Отмена',
  onConfirm,
  onCancel,
  danger = false,
  busy = false,
}: {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  danger?: boolean;
  busy?: boolean;
}) {
  useEscape(onCancel);

  return (
    <div
      className="overlay center"
      onClick={(event) => {
        if (event.target === event.currentTarget) onCancel();
      }}
    >
      <div className="dialog" role="dialog" aria-modal="true" aria-label={title}>
        <h2>{title}</h2>
        {children}
        <div className="acts">
          <button className="b" type="button" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={danger ? 'b d' : 'b p'}
            type="button"
            onClick={onConfirm}
            disabled={busy}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
